import { render } from "./PortfolioSection.vue?vue&type=template&id=1f0839a5&scoped=true"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=1f0839a5&scoped=true&lang=css"

import exportComponent from "/home/brandon/Code/Clients/PhilipComan/specialty-studio-vuetify-theme-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0839a5"]])

export default __exports__